export default {
    login: {
        heading: 'Hey there',
        subheading: 'Sign in to Bizly',
        email: 'Email',
        button: "Let's go",
        invalidEmail: 'Please enter a valid email.',
    },
    acceptInvite: {
        heading: 'Welcome to Bizly',
    },
};
